import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import Error from "types/error";
import { Acquisition } from "types/acquisition";
import { generatePath } from "react-router-dom";

export default function useAcquisition(id: string | undefined) {
  const request: Request = {
    url: generatePath(ENDPOINTS.acquisitions.one, { id }),
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.acquisitions.one, id],
    queryFn: () => client(request),
    enabled: !!id,
  };

  const { data, ...rest } = useQuery<Response<Acquisition>, Error>(
    requestConfig
  );

  return { data, ...rest };
}
